// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,

  //dev
  // AuthURL:"https://devauth.digisparsh.in",
  // UserURL:"https://devuser.digisparsh.in",
  // AdminURL:"https://devadmin.digisparsh.in",
  // case_rep:93,
  // isEncrypted:false,

  //uat
  // AuthURL: "https://uatauth.digisparsh.in",
  // UserURL: "https://uatuser.digisparsh.in",
  // AdminURL: "https://uatadmin.digisparsh.in",
  // case_rep: 93,
  // isEncrypted: true,

  // // live
  AuthURL: "https://auth.digisparsh.in",
  UserURL: "https://user.digisparsh.in",
  AdminURL: "https://admin.digisparsh.in",
  case_rep: 221,
  isEncrypted: true,

  // local
  // AuthURL: "http://localhost:3061",
  // UserURL: "http://localhost:3063",
  // AdminURL: "http://localhost:3062",
  // case_rep: 93,
  // isEncrypted: false,

  // AuthURL:"https://ff59-103-15-67-130.ngrok-free.app",
  // UserURL:"https://b647-103-15-67-130.ngrok-free.app",
  // AdminURL:"https://cec8-103-15-67-130.ngrok-free.app",
  // case_rep: 93,
  // isEncrypted: false,

  //   AuthURL: "https://36d5-103-15-67-130.ngrok-free.app",
  //   AdminURL: "https://5236-103-15-67-130.ngrok-free.app",
  //   UserURL: "https://94c4-103-15-67-130.ngrok-free.app",

  // case_rep:93,
  // isEncrypted:false,
  // AuthURL:"https://32ndzm8q-3061.inc1.devtunnels.ms",
  // AdminURL:"https://32ndzm8q-3062.inc1.devtunnels.ms",
  // UserURL:"https://32ndzm8q-3063.inc1.devtunnels.ms",

  // ngrok

  // AuthURL:"https://36d5-103-15-67-130.ngrok-free.app",
  // AdminURL:"https://5236-103-15-67-130.ngrok-free.app",
  // UserURL:"https://94c4-103-15-67-130.ngrok-free.app",

  // case_rep:93,
  // isEncrypted:false,
  // AdminURL:"https://e330-103-15-67-125.ngrok.io",

  //  AuthURL: "https://5a1b-103-15-67-125.ngrok.io",
  //  UserURL: "https://f51a-103-15-67-125.ngrok.io",
  //  AdminURL: "https://b58e-103-15-67-125.ngrok.io",

  // Azure
  // UserURL:"http://10.5.0.229:3063",
  // AdminURL:"http://10.5.0.227:3062",
  // AuthURL:"http://10.5.0.228:3065",

  URLP: "https://20.204.86.75:8000",
  accountName: "uatresource",
  containerName: "uatcontainer",
  key: "uaEjdcwzjVO7U7qv/JFnOnsEXUxQHQ46zI4x+onZBXL9UPCLEfEk+xd0sMB0ZWmZGuRLXdxjDzBIUba3A5CUrw==",
};
